import React from 'react';
import Market from '../components/stocks/Market';
import MarketMarquee from '../components/stocks/MarketMarque';

function Special() {

    return (
        <div className="special-container">
            {/* Intro Text Block */}
            <div className="special-intro">
                <h2 className="hero-title">Exclusive Investment Access</h2>
                <p className="box-text centered">
                    Welcome to a special tier of investment opportunities. Unlike our standard trading dashboard,
                    this section unlocks unique staking rates, curated market options, and priority access to
                    Mega FXT schemes. Designed for ambitious investors looking to maximize returns with exclusive tools.
                    You can select any of the available crypto node options to gain access to special plans,
                    enabling you to trade at preferential rates and enjoy exclusive benefits.
                </p>
            </div>
            <div>
                <MarketMarquee />
            </div>
            {/* Market Section */}
            <div className="market-section">
                <Market />
            </div>
        </div>
    );
}

export default Special;
